module.exports = __webpack_public_path__ + "media/my_images/top/rec_box_text-57682ba52a91fa6b0b0ce5bc70188734.svg";